import { render, staticRenderFns } from "./UpdateKPI.vue?vue&type=template&id=642ad7c3"
import script from "./UpdateKPI.vue?vue&type=script&lang=js"
export * from "./UpdateKPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports